import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import FuelRates from './pages/FuelRates';
import DailySheet from './pages/DailySheet';
import MorningReadings from './pages/MorningReadings';
import MasterConfig from './pages/MasterConfig';
import LubeConfig from './pages/LubeConfig';
import EmployeeConfig from './pages/EmployeeConfig';
import CreditorConfig from './pages/CreditorConfig';
import CreditorLedger from './pages/CreditorLedger';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import DSR from './pages/DSR';
import StockDifference from './pages/StockDifference';
import Invoice from './pages/Invoice';
import CreditSales from './pages/CreditSales';
import StockStatement from './pages/StockStatement';
import EmployeeShortages from './pages/EmployeeShortages';
import Login from './pages/Login';

const ProtectedRoute = ({ children, isAuthenticated }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const AdminRoute = ({ children }) => {
  const role = localStorage.getItem('role');
  if (role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  // Prevent mouse scroll from changing number inputs globally
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };
    
    // Using passive: false is required to allow preventDefault if we wanted to use it,
    // but blurring is the safest cross-browser way to stop the scroll-to-change behavior.
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => window.removeEventListener('wheel', handleWheel);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} />
        
        <Route path="/" element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <MainLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="morning-readings" element={<MorningReadings />} />
          <Route path="fuel-rates" element={<FuelRates />} />
          <Route path="credit-sales" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CreditSales /></ProtectedRoute>} />
          <Route path="/master-config" element={<ProtectedRoute isAuthenticated={isAuthenticated}><MasterConfig /></ProtectedRoute>} />
          <Route path="/lube-config" element={<ProtectedRoute isAuthenticated={isAuthenticated}><LubeConfig /></ProtectedRoute>} />
          <Route path="/employees" element={<ProtectedRoute isAuthenticated={isAuthenticated}><EmployeeConfig /></ProtectedRoute>} />
          <Route path="/creditors" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CreditorConfig /></ProtectedRoute>} />
          <Route path="/ledger" element={<ProtectedRoute isAuthenticated={isAuthenticated}><CreditorLedger /></ProtectedRoute>} />
          <Route path="/daily-sheet" element={<ProtectedRoute isAuthenticated={isAuthenticated}><DailySheet /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Settings /></ProtectedRoute>} />
          <Route path="reports" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Reports /></ProtectedRoute>} />
          <Route path="dsr" element={<ProtectedRoute isAuthenticated={isAuthenticated}><DSR /></ProtectedRoute>} />
          <Route path="stock-difference" element={<ProtectedRoute isAuthenticated={isAuthenticated}><StockDifference /></ProtectedRoute>} />
          <Route path="invoice" element={<ProtectedRoute isAuthenticated={isAuthenticated}><Invoice /></ProtectedRoute>} />
          <Route path="stock-statement" element={<ProtectedRoute isAuthenticated={isAuthenticated}><StockStatement /></ProtectedRoute>} />
          <Route path="employee-shortages" element={<ProtectedRoute isAuthenticated={isAuthenticated}><EmployeeShortages /></ProtectedRoute>} />
        </Route>
      </Routes>
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;
